import { CustomFormProps } from '@FormModels/shared';
import { repaymentMethodConfig } from '@Shared/helpers/fullEarlyRepaymentMethods';
import { extractLeadingNumber } from '@Shared/helpers/string';

export enum DrawdownFlexibility {
    ALL_AT_ONCE = 'ALL_AT_ONCE',
    AS_NEEDED = 'AS_NEEDED',
}

export const accessArray = [
    { label: 'All at once', value: DrawdownFlexibility.ALL_AT_ONCE },
    { label: 'As needed', value: DrawdownFlexibility.AS_NEEDED },
];

export const loanPreferencesFormItems: CustomFormProps = {
    fullEarlyRepayment: {
        default: null,
        transform: {
            target: 'fullEarlyRepayment',
            toRequest: (value: string) => stringToBoolean(value),
        },
    },
    fullEarlyRepaymentYear: {
        default: null,
        transform: {
            target: 'fullEarlyRepaymentYear',
            toRequest: (value: string) => extractLeadingNumber(value),
        },
    },
    fullEarlyRepaymentMethod: {
        default: null,
        transform: {
            target: 'fullEarlyRepaymentMethod',
            toRequest: (value?: string) => mapFullEarlyRepaymentMethod(value),
        },
    },
    drawdownFlexibility: {
        default: null,
        transform: {
            target: 'drawdownFlexibility',
            toRequest: (value?: string) => value || undefined,
        },
    },
    drawdownFlexibilityTerm: {
        default: null,
        transform: {
            target: 'drawdownFlexibilityTerm',
            toRequest: (value: string) => extractLeadingNumber(value),
        },
    },
    monthlyOverpaymentsPlanned: {
        default: null,
        transform: {
            target: 'monthlyOverpaymentsPlanned',
            toRequest: (value: string) => stringToBoolean(value),
        },
    },
    yearlyOverpaymentAmountKnown: {
        default: null,
        transform: {
            target: 'yearlyOverpaymentAmountKnown',
            toRequest: (value: string) => stringToBoolean(value),
        },
    },
    neededAmountAndTimeKnown: {
        default: null,
        transform: {
            target: 'neededAmountAndTimeKnown',
            toRequest: (value: string) => stringToBoolean(value),
        },
    },
    moreThan10PercentNoFeesOverpaymentPlanned: {
        default: null,
        transform: {
            target: 'moreThan10PercentNoFeesOverpaymentPlanned',
            toRequest: (value: string) => stringToBoolean(value),
        },
    },
};

const stringToBoolean = (string?: string): boolean | undefined => {
    if (!string) {
        return undefined;
    }
    return string.toLowerCase() === 'true';
};

export const mapFullEarlyRepaymentMethod = (value?: string) =>
    repaymentMethodConfig.find((method) => method.value === value)?.enumValue;
